import { render } from "./new.vue?vue&type=template&id=5ed7a1b4&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "./new.vue?vue&type=style&index=0&id=5ed7a1b4&scoped=true&lang=css"

import exportComponent from "/Users/charcoaldev/Documents/GitHub/beardrug-pos/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed7a1b4"]])

export default __exports__